import { CSSProperties, useEffect, useRef, useState } from "react";
import OliverImage from "../OliverImage";
import "./style.scss";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

interface SidebarCollapseProps {
    title: string;
    children: React.ReactNode;
    open?: boolean;
    styles?: CSSProperties;
    parent?: HTMLDivElement;
}

const SidebarCollapse: React.FC<SidebarCollapseProps> = ({ title, children, styles, parent }: SidebarCollapseProps) => {
    const { t } = useTranslation();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (parent && ref.current) {
            const { top, bottom } = ref.current.getBoundingClientRect();
            const { top: parentTop, bottom: parentBottom } = parent.getBoundingClientRect();
            setIsCollapsed(bottom < parentTop || top > parentBottom);
        }
    }, [parent]);

    const handleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className="sidebar-collapse-wrapper" ref={ref}>
            <div className="title-row" onClick={handleCollapse}>
                <OliverText text={t("sidebarCollapse." + title)} size="xs" />
                <OliverImage
                    src="/angled-arrow-down.svg"
                    style={{
                        transition: "transform 0.2s linear",
                        transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)"
                    }}
                />
            </div>
            {!isCollapsed && (
                <div className="sidebar-collapse-content" style={styles}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default SidebarCollapse;
